import React from 'react';
import ReactTable from 'react-table';

const TableCard = (props) => {
    const { title, data, loading, headers }  = props;
    const columns = [{
        Header: headers[0],
        accessor: 'title',
      },{
        Header: headers[1],
        accessor: 'value', // String-based value accessors!
      }]

    return (
        <div className="bg-white rounded shadow">
            <div className="pt-4 px-4">
                <h5>{title}</h5>
            </div>
            <br/>
            {
                loading ? 
                <div className="px-4 pb-4">
                    Loading...
                </div> :
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={5}
                    loading={loading}
                    showPaginationBottom={false}
                    className="-striped -highlight"
                />
            }
        </div>
    );
};

export default TableCard;
